import React, { ReactNode } from "react";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";

type Props = {
  mainTitle: string | React.ReactElement;
  subTitle?: string | React.ReactElement;
  children?: ReactNode;
};

export const PageTitle = ({ mainTitle, subTitle, children }: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : spModeContainer}>
      <div css={!isSpMode ? {} : spModeMain}>
        <Font variant="xlb" component="h2">
          {mainTitle}
        </Font>
      </div>
      {children}
      {subTitle && (
        <div css={!isSpMode ? sub : spModeSub}>
          {typeof subTitle !== "string" ? (
            subTitle
          ) : (
            <Font variant="l" component="p">
              {subTitle}
            </Font>
          )}
        </div>
      )}
    </div>
  );
};

const container = css({
  marginBottom: "32px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const spModeContainer = css({
  marginBottom: "27px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const spModeMain = css({
  textAlign: "center",
  padding: "0px 30px",
});

const sub = css({
  textAlign: "center",
  marginTop: "32px",
});

const spModeSub = css({
  marginTop: "20px",
});
